import base from '../base/base.js';
import ClipboardJS from 'clipboard';

const tool = {};

// 设置标题,设置微信web的title,主要为兼容IOS微信端
tool.setDocTitle = (function () {
  if (base.env === 'wx') {
    // iOS微信6.5.3及其之后的版本 window.__wxjs_is_wkwebview 为true时是使用WKWebview，为 false或者 “undefine”时是 UIWebview 。
    if ((base.isIDevice || base.isTouchPad) && !window.__wxjs_is_wkwebview) {
      return setDocTitleToIOS;
    } else {
      return setDocTitleToOther;
    }
  } else if (base.env === 'dd') {
    return setDocTitleToDingTalk;
  } else if (base.env === 'xgj') {
    /** 暂时适配app的修改标题 */
    // iOS微信6.5.3及其之后的版本 window.__wxjs_is_wkwebview 为true时是使用WKWebview，为 false或者 “undefine”时是 UIWebview 。
    if ((base.isIDevice || base.isTouchPad) && !window.__wxjs_is_wkwebview) {
      return setDocTitleToIOS;
    } else {
      return setDocTitleToOther;
    }
    // return function (titleStr) {
    //     app.sdk.setTitle(titleStr);
    // };
  } else {
    return setDocTitleToOther;
  }

  //  微信环境下并且 'UIWebview'的苹果设备设置title
  function setDocTitleToIOS(titleStr) {
    var doc = document;
    doc.title = titleStr;
    var iframe = doc.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = '/favicon1.ico';

    // iframe.src = "http://www.xiaogj.com/favicon.ico";
    // iframe.src = "/abc/abc";
    iframe.addEventListener('load', function () {
      setTimeout(function () {
        doc.body.removeChild(iframe);
      }, 0);
    });
    doc.body.appendChild(iframe);
  }

  // 其它设备设置title
  function setDocTitleToOther(titleStr) {
    setTimeout(() => {
      document.title = titleStr;
    }, 50);
  }

  // 钉钉环环境下设置title
  function setDocTitleToDingTalk(titleStr) {
    dd.biz.navigation.setTitle({
      title: titleStr, // 控制标题文本，空字符串表示显示默认文本
    });
  }
})();

// 将类似location中的字符串查询参数解析为对象
// http://www.baidu.com?name=jiajie&age=31&sex=1
tool.parseQuery = function (str = location.search) {
  let qs = str.indexOf('?') === -1 ? str : str.split('?')[1];
  if (qs.length > 0) {
    let s,
      q = {},
      arr = [];
    arr = qs.split('&');
    for (let i = 0; i < arr.length; i++) {
      if (!arr[i]) continue;
      s = arr[i].split('=');
      q[s[0]] = s[1];
    }
    return q;
  } else {
    return {};
  }
};

// 将location中的hash解析为包含hash、查询参数的对象
// http://mall.xiaogj.com/malltest/html/index.html#/details/1/5?cid=42
tool.parseHash = function (fullFash = location.hash) {
  var queryStr = '',
    query = {},
    arr = fullFash.split('?'),
    hash = arr[0];
  if (arr.length > 1) {
    queryStr = arr[1];
    query = tool.parseQuery(queryStr);
  }
  return {
    fullFash: fullFash,
    hash: hash,
    hashArr: hash.slice(2).split('/'),
    queryStr: queryStr,
    query: query,
  };
};

// 将简单json对象转化为查询参数字符串;
tool.jsonToQueryStr = function (obj) {
  let key,
    query = [];
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      query.push(`${key}=${obj[key]}`);
    }
  }
  return '?' + query.join('&');
};

tool.clone = function (obj) {
  let map = new WeakMap(); //循环引用
  function recursion(value) {
    if (typeof value !== 'object' || value === null) {
      return value;
    }

    if (map.get(value)) {
      return map.get(value);
    }

    let cloneObj;
    if (Array.isArray(value)) {
      cloneObj = [];
      map.set(value, cloneObj);
      cloneObj.push(...value.map(item => recursion(item)));
    } else {
      cloneObj = {};
      map.set(value, cloneObj);
      Object.keys(value).forEach(key => (cloneObj[key] = recursion(value[key])));
    }
    return cloneObj;
  }
  return recursion(obj);
};

function toFixedFix(n, prec) {
  var k = Math.pow(10, prec);
  return '' + (Math.round(n * k) / k).toFixed(prec);
}

/**
 * 格式化数字
 * @param number 必需，要格式化的数字
 * @param decimals 可选，规定多少个小数位，默认两位。
 * @param point 可选，规定用作小数点的字符串（默认为 . ）。
 * @param thousands 可选，规定用作千位分隔符的字符串（默认为 , ），如果设置了该参数，那么所有其他参数都是必需的。
 */
tool.formatNumber = function formatNumber(number, decimals, point, thousands) {
  //https://github.com/txgruppi/number_format
  //form http://phpjs.org/functions/number_format/
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 2 : Math.abs(decimals),
    sep = typeof thousands === 'string' ? thousands : ',',
    dec = point || '.',
    s = '';

  // Fix for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  return s.join(dec);
};

/**
 * 在formatNumber的基础上,百万级别用万为单位.
 */
tool.formatNumberUnit = function formatNumberUnit(value) {
  const unit = '万';
  if (parseFloat(value) > 1000000) {
    value = value / 10000;
    let args = [...arguments];
    args[0] = value;
    return tool.formatNumber(...args) + unit;
  } else {
    return tool.formatNumber(...arguments);
  }
};

// 格式化数字为最多2位小数，并且不大于传于的max值
let regx = /^(([1-9]{1}\d{0,99})|(0{1}))(\.\d{0,2})?$/;
tool.format2MaxWrap = function (max) {
  return function (value) {
    return tool.format2Max(value, max);
  };
};
tool.format2Max = function (value, max) {
  if (value.length > 0 && Number(value) > Number(max)) {
    value = max;
  }
  if (regx.test(value)) {
    return value;
  } else {
    return value.split('').slice(0, -1).join('');
  }
};

let regx1 = /^(([1-9]{1}\d{0,99})|(0{1}))?$/;
// let regx1 = /[^0-9]/g;
tool.formatMaxWrap = function (max) {
  return function (value) {
    return tool.formatMax(value, max);
  };
};
tool.formatMax = function (value, max) {
  if (value.length > 0 && Number(value) > Number(max)) {
    value = max;
  }
  if (regx1.test(value)) {
    return value;
  } else {
    return value.split('').slice(0, -1).join('');
  }
};

// 将一个数格式化成指定位数小数，在比较数值是否相等时可以用用
// 比如: formatFloat(0.1+0.2, 1) == 0.3
tool.formatFloat = function (f, digit) {
  var m = Math.pow(10, digit);
  return parseInt(Math.round(f * m), 10) / m;
};

function isUde(val) {
  return val === undefined || val === null;
}

/**
 * 安全获取对象的深层属性，如果中途遇到非对象值，返回null
 * 可以避免深层属性访问报错
 * obj 对象
 * props, 要获取的属性值，支持数组和字符串，如['a', 'b', 'c']/'a.b.c',返回obj.a.b.c的值
 */
tool.safeReadObjProp = function safeReadObjProp(obj, props) {
  if (typeof obj !== 'object' || obj === null) return undefined;
  if (typeof props === 'string') props = props.split('.');
  if (!Array.isArray(props) || props.length === 0) return undefined;
  let copyProps = [...props];
  let prop = copyProps.shift().toString();
  let val = obj[prop];
  while (!isUde(val) && copyProps.length > 0) {
    prop = copyProps.shift().toString();
    val = val[prop];
    if (isUde(val)) return val;
  }
  return val;
};

tool.debounce = function (fn, delay) {
  let timer;

  let returnFn = function (...args) {
    let context = this;

    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(context, args);
    }, delay);
  };

  returnFn.clear = () => {
    timer && (clearTimeout(timer), (timer = null));
  };
  return returnFn;
};

// 间隔指定时间
tool.timeout = function timeout(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}


// 复制字符内容到剪贴板
tool.copy = async function copy (content) {
  let inp = window._copyInput_
  if (!inp) {
    inp = window._copyInput_ = document.createElement('input');
    inp.style.position = 'absolute';
    inp.style.left = '-100000px';
    inp.style.zIndex = '-1000';
    // 防止ios聚焦触发键盘事件
    inp.readOnly = 'readOnly'; 
    document.body.appendChild(inp);
  }
  let copyStr = `${content}`
  inp.value = copyStr
  await tool.timeout(60)
  inp.select();
  inp.setSelectionRange(0, copyStr.length);
  document.execCommand('copy');
  inp.blur();
  vant.Toast.success('复制成功');
  return Promise.resolve('复制成功')
}

// 复制字符内容到剪贴板
tool.copyNew = function (content) {
  let inp = window._copyButton_
  if (!inp) {
    inp = window._copyButton_ = document.createElement('button');
    inp.style.position = 'absolute';
    inp.style.left = '-100000px';
    inp.style.zIndex = '-1000';
    inp.classList.add('cp-button')
    inp.innerText = 'copy'
    inp.setAttribute('data-clipboard-text', content);
    document.body.appendChild(inp);
  }
  // let copyStr = `${content}`
  setTimeout(() => {
    const cp = new ClipboardJS('.cp-button');
    cp.on('success', () => {
      vant.Toast.success('复制成功');
    });
    window._copyButton_.click()
    window._copyButton_.remove();
    window._copyButton_ = null
  }, 100);
}

export default tool;
